<template>
    <BreadCrumb PageTitle="Modifier une règle de tarification" />
    <EditPricingRule/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditPricingRule from "@/components/RegleTarification/EditPricingRule.vue";
  
    export default defineComponent({
      name: "EditBescPricingRulePage",
      components: {
        BreadCrumb,
        EditPricingRule,
      },
    });
  </script>